import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const CALENDAR_PLAN_NAMES = {
  CURRENCY: 'currency',
  VARIANTS: 'variants',
  TABLE: 'table',
  TOTAL: 'total',
} as const;

const calendarPlanVariants = [
  'Own funds',
  'Borrowed funds',
  'Investment funds',
];

export interface ICalendarPlanFormValuesType {
  [CALENDAR_PLAN_NAMES.VARIANTS]: string[];
  [CALENDAR_PLAN_NAMES.TABLE]: IPeriodsTableRow[];
  [CALENDAR_PLAN_NAMES.TOTAL]: IPeriodsTableRow;
}

export const calendarPlanInitialValues = {
  [CALENDAR_PLAN_NAMES.VARIANTS]: calendarPlanVariants,
  [CALENDAR_PLAN_NAMES.TABLE]: getFormTableInitialValues2(calendarPlanVariants.length, initialPeriodsTableRow),
  [CALENDAR_PLAN_NAMES.TOTAL]: initialPeriodsTableRow,
};
